import React from 'react';
import styled from '@emotion/styled';
import { Only } from 'ui/components/elements/Only/Only';
import { mqMin } from 'utils/responsive';
import Img01Sp from 'ui/images/top_for_agent/topIssue_img01_sp@2x.png';
import Img01SpPng from 'ui/images/top_for_agent/topIssue_img01_pc@2x.png';
import Img01PcPng from 'ui/images/top_for_agent/topIssue_img01_pc@2x.png';
import Img02Sp from 'ui/images/top_for_agent/topIssue_img02_sp@2x.png';
import Img02Pc from 'ui/images/top_for_agent/topIssue_img02_pc@2x.png';

const Section = styled.section`
    background-color: #e7e7e7;
    padding: 48px 0 60px 0;

    ${mqMin('NARROW')} {
        padding: 77px 0 77px 0;
    }
`;

const Lead = styled.p`
    text-align: center;
    line-height: 1.7em;
    letter-spacing: 0.1em;
    margin-bottom: 30px;

    ${mqMin('NARROW')} {
        margin-bottom: 15px;
    }
`;

const H2 = styled.h2`
    text-align: center;
    font-size: 1.3125rem; /*21px*/
    line-height: 1.4em;
    letter-spacing: 0.1em;
    margin-bottom: 30px;

    strong {
        font-size: 1.8125rem;
    }
`;

const Img01Container = styled.div`
    width: 83.72093023255814%;
    max-width: 360px;
    margin: 0 auto 16px auto;

    ${mqMin('NARROW')} {
        width: 633px;
        max-width: initial;
        margin: 0 auto 0 auto;
    }
`;

const Img02Container = styled.div`
    width: 93.02325581395349%;
    max-width: 400px;
    margin: 0 auto 36px auto;

    ${mqMin('NARROW')} {
        width: 876px;
        max-width: initial;
        margin: -20px auto 28px auto;
    }
`;

const Text = styled.div`
    text-align: center;
    font-size: 1.375rem; /*22px*/
    line-height: 1.8em;
    letter-spacing: 0.1em;

    ${mqMin('NARROW')} {
        font-size: 1.5rem;
    }

    span {
        font-size: 1.25rem;
    }
`;

export const Issue: React.FC = () => {
    return (
        <Section>
            <Lead className="fadein fadein_y">
                国内M&A支援機関は年々増加し、
                <Only sp>
                    <br />
                </Only>
                顧客開拓はさらに困難に…
            </Lead>
            <H2 className="fadein fadein_y">
                顧客開拓の
                <Only sp>
                    <br />
                </Only>
                こんな<strong>お悩み</strong>ありませんか？
            </H2>

            <Img01Container className="fadein fadein_y">
                <picture>
                    <source media="(max-width: 1023px)" srcSet={Img01Sp} />
                    <source media="(min-width: 1024px)" srcSet={Img01SpPng} />
                    <img src={Img01PcPng} alt="大量のDM送付。費用をかけて営業を外注。M&Aマッチングサイトで新規開拓。" />
                </picture>
            </Img01Container>
            <Img02Container className="fadein fadein_y">
                <picture>
                    <source media="(max-width: 1023px)" srcSet={Img02Sp} />
                    <source media="(min-width: 1024px)" srcSet={Img02Pc} />
                    <img src={Img02Pc} alt="しかし・・・具体的な話に繋がらない。アポすら取れない。" />
                </picture>
            </Img02Container>

            <Text className="fadein fadein_y">
                リード獲得コスト<span>は</span>増える一方...
            </Text>
        </Section>
    );
};
